import { apiFetch } from '@/api/apiFetch';
import type { ListAppNotificationsResponse, UnreadCountResponse } from './AppNotifications.types';

const PAGE_SIZE = 20;

export const getNotifications = async (offset: number): Promise<ListAppNotificationsResponse> => {
  const params = new URLSearchParams({
    limit: String(PAGE_SIZE),
    offset: String(offset),
  });
  const res = await apiFetch(`/notifications?${params}`, {
    method: 'GET',
  });
  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(err?.error ?? res.statusText);
  }
  return (await res.json()) as ListAppNotificationsResponse;
};

export const markNotificationRead = async (id: string): Promise<void> => {
  const res = await apiFetch(`/notifications/${id}/read`, {
    method: 'PATCH',
  });
  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(err?.error ?? res.statusText);
  }
};

export const getUnreadNotificationsCount = async (): Promise<UnreadCountResponse> => {
  const res = await apiFetch(`/notifications/unread-count`, {
    method: 'GET',
  });
  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(err?.error ?? res.statusText);
  }
  return (await res.json()) as UnreadCountResponse;
};

export { PAGE_SIZE };
